import { AppHeader, Avatar } from '@nike/eds'
import { useOktaAuth } from '@okta/okta-react'
import { useMemo } from 'react'
import { GlobalSearch } from './GlobalSearch'
import { GeoSelector } from './GeoSelector'
import { Text } from '@nike/eds'
import './header.css'
export function Header({ isDark, globalSearch, setGlobalSearch, currentGeos, setCurrentGeos }: { isDark: boolean, globalSearch: string, setGlobalSearch: (value: string) => void, currentGeos: string[], setCurrentGeos: (value: string[]) => void }) {
    const { authState } = useOktaAuth()
    const initials = useMemo(() => {
        const name = authState?.accessToken?.claims?.sub
        return name ? getInitials(name) : '-'
    }, [authState])

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setGlobalSearch(e.target.value);
    };

    return (
        <AppHeader
            className='eds-elevation--1'
            appName={<Text font="display-4">Customs Compliance Hub</Text>}
            isDark={isDark}
            toolbarSlot={
                <div className='header-toolbar eds-flex eds-gap--32'>
                    <GlobalSearch globalSearch={globalSearch} handleGlobalSearchChange={handleSearchChange} />
                    <GeoSelector currentGeos={currentGeos} setCurrentGeos={setCurrentGeos} />
                </div>
            }
            avatarSlot={<Avatar initials={initials} size={36} />}
        />
    )
}

function getInitials(name: string) {
    const matchedFirstLetters = name.match(/(\b[A-Z])/g)
    if (!matchedFirstLetters || matchedFirstLetters.length < 2) {
        // Fallback: take first letter
        return name[0]?.toUpperCase()
    }
    return `${matchedFirstLetters.shift()}${matchedFirstLetters.pop()}`
}
